import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const QR = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel8-content"
                id="panel8-header"
            >
                How to create and print functional QR codes?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    In Dippi we have two version designs of Dippi QR codes that you can put on your
                    physical label, after downloading QR code, you will be presented with 2 version
                    - Dark and Light:
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Version 1 has a dark structure to be applied on a white/colored label" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Version 2 has a light color structure to be applied over a black/dark label" />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography variant="body2">
                    All QR codes must have a white area (Quiet zone) where there is at least 0.16 cm
                    of empty space around the QR code.
                </Typography>
                <Typography variant="body2">
                    Keep enough contrast between the label and the QR code to make the QR stand out
                    and be easily seen by the mobile camera, if the label is colored or light in
                    color, use the dark QR code shown on the first slide of this guide (Version 1 QR
                    code), if Label is dark - white QR code (Version 2 QR code).
                </Typography>
                <Typography variant="body2">
                    The minimum recommended size is 1.3x1.3 cm, bordered by at least 0.16 cm of
                    white on each side.
                </Typography>
                <Typography variant="body2">
                    The maximum size of the printed QR code should preferably not exceed 3x3 cm
                </Typography>
                <Typography variant="body2">
                    Note the minimum size of QR codes on packaging. If the code is too small it will
                    be hard to read or not scannable at all, making them useless.
                </Typography>
                <Typography variant="body2">
                    For the best quality QR code printing, it is recommended that you confirm with
                    your own label designer and/or print provider that the QR code image you have
                    can be printed on a label at 300 dpi or higher in the dimensions you want, and
                    the QR code we provide will match this data.
                </Typography>
                <Typography className="heading">QR Explained</Typography>
                <Typography variant="body2">
                    When generating a QR code in Dippi, the resulting short URL begins with
                    info.dippi.app, guiding the consumer to a Dippi digital label page. QR Code
                    =&gt; Dippi =&gt; Dippi digital label page. Fee: Dippi subscription is
                    necessary. Additional effort on your part: None.
                </Typography>
                <Typography className="heading">Troubleshooting</Typography>
                <Typography variant="body2">
                    Why isn't your QR code functioning? These are the primary reasons your QR code
                    may not be operational:
                </Typography>
                <Styled.UnorderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Deleted the QR code in Dippi." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Did not maintain a basic subscription in Dippi." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Insufficient contrast in the QR code colors. Regrettably, you'll need to modify your labels by enhancing the contrast." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Placed the QR code on a busy background. Unfortunately, a redesign is necessary, incorporating a margin." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="The QR code size was inadequate. Unfortunately, you'll need to revisit your labels, increasing the size beyond 1.3 cm²." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="The QR code printing lacked sharpness. Consult with your printers." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Printed on a reflective or distorting material for the QR code. Discuss this with your printers." />
                    </Styled.ListItem>
                </Styled.UnorderedList>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default QR;
